import * as i0 from '@angular/core';
import { Directive, Input } from '@angular/core';
class DotModalContainerDirective {
  modal;
  static ɵfac = function DotModalContainerDirective_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotModalContainerDirective)();
  };
  static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DotModalContainerDirective,
    selectors: [["", "dotModalContainer", ""]],
    inputs: {
      modal: "modal"
    }
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotModalContainerDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[dotModalContainer]'
    }]
  }], null, {
    modal: [{
      type: Input
    }]
  });
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotModalContainerDirective };
